import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components
import styles from "../ServicesSections.module.scss";



export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>Other Services We offer</h3>
          <p>
            See below for a list of all the other services we offer. We are
            updating specific pages for these services as we speak, but for now
            please follow the short summaries below and dont hesitate to reach
            out to us through our contact form below or through a direct call.
            We’d ove to discuss working with you.
          </p>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <ul>
            <li>App Development & Design</li>
            <ul>
              <li>
                In combination with our partners{" "}
                <a href="https://wwww.flexisourceit.com.au">FlexisourceIT</a> we
                offer app development and tracking services. We assisted in the
                launch of the Q by Quallogi app. Contact us for more info.
              </li>
            </ul>
            <li>Email Marketing</li>
            <ul>
              <li>
                We offer email marketing services and manage current client
                campaigns through the following platforms Mailchimp,
                ActiveCampaign and Salesforce. Contact us for more info.
              </li>
            </ul>
            <li>Graphic Design</li>
            <ul>
              <li>
                In combination with our partners{" "}
                <a href="https://wwww.flexisourceit.com.au">FlexisourceIT</a>{" "}
                and <a href="https://www.messy.com.au">Messy Design</a> we have
                designed websites, advertising campaigns and corporate templates
                for various clients. Contact us for more info.
              </li>
            </ul>
            <li>Martech Integrations</li>
            <ul>
              <li>
                We have worked with various bespoke sales & CRM stacks but the
                ine that keeps popping up is salesforce. Especially for tracking
                online behaviour to offline sales - this is ome of our
                specialties having done it for multiple clients. Contact us for
                more info.
              </li>
            </ul>
            <li>Script Development</li>
            <ul>
              <li>
                We are especially strong on automation scripts on the google
                stack - mainly for reporting. We’ve also designed bespoke form
                integrations through Salsforce. Contact us for more info.
              </li>
            </ul>
            <li>Video/Photography</li>
            <ul>
              <li>
                Video is where it’s at. We’ve recognised this and it has become
                a huge part of our business. You need to have a video component
                to your ads now. Same with your website. We’ve developed entire
                videos from scripting, storyboarding, hiring actors and voice
                actors, to video editing and design. You don't have to be Steven
                Spielberg on Hollywood budgets to create engaging videos.
                Contact us for more info.
              </li>
            </ul>
          </ul>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Our guarantee to you</h3>

          <ol>
            <li>
              Quality: We will deliver quality work. It's the first thing all of
              our staff are trained in - “completed” is not good enough - it
              needs to be done well!
            </li>
            <li>
              Communication: We cannot guarantee that everything will be perfect
              the first time. Most things aren't. But what we can guarantee is
              easy communication to anyone in our business to discuss any issues
              and fix any problems asap.
            </li>
            <li>
              Innovative: We are anti-silo. Like life - you can't just focus on
              one thing to fix your problems. We are well versed on every facet
              of this field - and with that comes innovative approaches to your
              business issues.
            </li>
          </ol>

          <br />
          <br />
          <br />
        </GridItem>
      </GridContainer>
    </div>
  );
}
